<section class="section section--verificationCode">
  <div class="container">
    <div class="wrapper">
      <div class="content fadeinright animation-duration-300">
        <form [formGroup]="formEmail" class="form full__height">
          <div class="content__main">
            <article class="mainInfo pb-30">
              <h1 class="pb-10">Código de verificación</h1>
              <p>Ingresa un <strong>correo electrónico válido</strong> para enviarte un código de verificación.</p>
            </article>

            <article class="finalMsg">
              <div class="form__group" [ngClass]="{'form__error': formEmail.get('email')?.invalid && (formEmail.get('email')?.dirty || isEmailSubmitted)}">
                <label class="form__label pb-5" for="email">Correo electrónico *</label>

                <p-autoComplete
                  type="email"
                  id="email"
                  formControlName="email"
                  [suggestions]="filteredDomains"
                  (completeMethod)="onDomainFilter($event)"
                  (onSelect)="onDomainSelect($event)"
                  [disabled]="loadingSendCode">
                </p-autoComplete>

                <!-- Indicador de validación en progreso -->
                <span class="form__msgValidate" *ngIf="formEmail.get('email')?.pending">
                  <small class="p-validate">
                    <i class="pi pi-spin pi-spinner"></i>
                    <span>Validando correo electrónico...</span>
                  </small>
                </span>

                <!-- Mensajes de error -->
                <span class="form__msgError" *ngIf="formEmail.get('email')?.invalid && (formEmail.get('email')?.dirty || isEmailSubmitted)">
                  <small class="p-error" *ngIf="formEmail.get('email')?.hasError('required')">El correo electrónico es requerido</small>
                  <small class="p-error" *ngIf="formEmail.get('email')?.hasError('email')">El correo electrónico no es válido</small>
                  <small class="p-error" *ngIf="formEmail.get('email')?.hasError('duplicate')">Este correo electrónico ya está registrado</small>
                  <small class="p-error" *ngIf="formEmail.get('email')?.hasError('invalid')">El correo electrónico tiene un estado inválido</small>
                  <small class="p-error" *ngIf="formEmail.get('email')?.hasError('serverError')">Error de conexión. Por favor, intenta nuevamente</small>
                </span>
              </div>
            </article>
          </div>

          <div class="content__footer">
            <button pButton pRipple label="Enviar código" icon="pi pi-angle-right" iconPos="right" class="p-button-primary p-button-raised p-button-rounded p-button-spaced w-full"
              (click)="onSendCode()"
              [disabled]="formEmail.invalid || formEmail.pending || loadingSendCode"
              [loading]="loadingSendCode">
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</section>


<p-dialog [(visible)]="visibleConfirmationModal" [modal]="true" [draggable]="false" [resizable]="false" [closable]="true" position="bottom">
  <div class="dialog">
    <div class="container">
      <div class="wrapper">
        <div class="dialog__info pb-40">
          <h2>Confirmación</h2>
          <p>Ingresá el código de <strong>4 dígitos</strong> que recibirás por correo electrónico para validar tu cuenta.</p>
        </div>

        <div class="dialog__form">
          <form [formGroup]="formCode" class="form" (ngSubmit)="onValidateCode()">
            <div class="dialog__content">
              <div class="form__groups form__groups--flex mb-15" [ngClass]="{'form__error': formCode.invalid && codeSubmitted}">
                <div class="form__group">
                  <input pInputText
                    type="text"
                    id="firstNumber"
                    #firstNumber
                    formControlName="firstNumber"
                    maxlength="1"
                    class="stepInput"
                    autocomplete="off"
                    (input)="onCodeInput($event, secondNumber)">
                </div>

                <div class="form__group">
                  <input pInputText
                    type="text"
                    id="secondNumber"
                    #secondNumber
                    formControlName="secondNumber"
                    maxlength="1"
                    class="stepInput"
                    autocomplete="off"
                    (input)="onCodeInput($event, thirdNumber)"
                    (keydown)="onCodeKeydown($event, firstNumber)">
                </div>

                <div class="form__group">
                  <input pInputText
                    type="text"
                    id="thirdNumber"
                    #thirdNumber
                    formControlName="thirdNumber"
                    maxlength="1"
                    class="stepInput"
                    autocomplete="off"
                    (input)="onCodeInput($event, fourthNumber)"
                    (keydown)="onCodeKeydown($event, secondNumber)">
                </div>

                <div class="form__group">
                  <input pInputText
                    type="text"
                    id="fourthNumber"
                    #fourthNumber
                    formControlName="fourthNumber"
                    maxlength="1"
                    class="stepInput"
                    autocomplete="off"
                    (keydown)="onCodeKeydown($event, thirdNumber)">
                </div>

                <span class="form__msgError form__msgError--center" *ngIf="formCode.invalid && codeSubmitted">
                  <small class="p-error" *ngIf="formCode.hasError('required') || getCodeValue().length < 4">El código es requerido</small>
                  <small class="p-error" *ngIf="formCode.hasError('invalid')">El código es inválido</small>
                </span>

                <span class="form__msgValidate form__msgValidate--center" *ngIf="loadingValidateCode">
                  <small class="p-validate">
                    <i class="pi pi-spin pi-spinner"></i>
                    <span>Validando código...</span>
                  </small>
                </span>
              </div>
            </div>

            <div class="dialog__footer pb-15">
              <button pButton pRipple
                type="submit"
                label="Validar código"
                icon="pi pi-angle-right"
                iconPos="right"
                class="p-button-primary p-button-raised p-button-rounded p-button-spaced w-full"
                [loading]="loadingValidateCode"
                [disabled]="formCode.invalid || loadingValidateCode">
              </button>
            </div>

            <div class="dialog__ref">
              <div class="retrySend">
                <div class="retrySend__text">
                  <p>Si no ves el correo, revisá tu carpeta de spam. Si aún así no lo recibiste, podrás volver a intentarlo una vez transcurrido el tiempo indicado:</p>
                </div>

                <div class="retrySend__time" *ngIf="!canResendCode">
                  <p>Tiempo para el próximo reintento: {{ timeNewCodeSending.minutes | number:'2.0-0' }}:{{ timeNewCodeSending.seconds | number:'2.0-0' }} min.</p>
                </div>

                <div class="retrySend__btn" *ngIf="canResendCode">
                  <p-button
                    styleClass="blue"
                    label="Reenviar código"
                    icon="pi pi-sync pi-small"
                    iconPos="right"
                    [text]="true"
                    [plain]="true"
                    (onClick)="onResendCode()">
                  </p-button>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</p-dialog>
